import { qualityApiClient } from '@/shared/api/core/axios-instance';

import type { DataZoneLowerCaseString } from '@/entities/quality/domain/type';

export type StatsTablesApiParams = {
  dataZone?: DataZoneLowerCaseString;
  namespace?: string;
  sortBy?: 'tableName' | '-tableName' | 'createdAt' | '-createdAt' | 'dataZone' | 'namespace';
};

export type StatsTableItem = {
  id: number;
  fqn: string;
  dataZone: string;
  namespace: string;
  tableName: string;
  columns: string[];
  isActive: boolean;
  createdAt: string;
};

export type StatsTablesApiResult = {
  success: boolean;
  data: StatsTableItem[];
  meta: {
    total: number;
  };
};

export const getStatsTables = async (params: StatsTablesApiParams): Promise<StatsTablesApiResult> => {
  try {
    const { data } = await qualityApiClient.get<StatsTablesApiResult>('/stats/tables', { params });
    return data;
  } catch (error) {
    console.error('Failed to fetch stats tables:', error);
    throw error;
  }
};
